module.exports = __webpack_public_path__ + "040c4287a3703c1155723bb23da93730.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/gb-wls.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/gb-wls.svg
// module chunks = 0